import {addModule, addModules, removeModule, removeModules, updateModule} from './moduleActions'
import {Constants} from './moduleConstants'
import {ApprenticeshipModule} from '../../../../model/apprenticeshipModule.model'

type Actions =
	| ReturnType<typeof addModule>
	| ReturnType<typeof addModules>
	| ReturnType<typeof updateModule>
	| ReturnType<typeof removeModule>
	| ReturnType<typeof removeModules>


export function moduleReducer(
	state: ApprenticeshipModule[] = [],
	action: Actions
) {
	switch (action.type) {
		case Constants.ADD_MODULE:
			return [...state, action.payload]

		case Constants.ADD_MODULES:
			return [...state, ...action.payload]

		case Constants.UPDATE_MODULE:

			return state.map((module) => {
				// if id does not match, return non changed item
				if (module.apprenticeship_module_id !== action.payload.apprenticeship_module_id) {
					return module
				}

				// replace with the updated item
				return {
					...module,
					...action.payload
				}
			})
		case Constants.REMOVE_MODULE:
			return state.filter((module: ApprenticeshipModule) => module?.apprenticeship_module_id !== action.payload)
		case Constants.REMOVE_MODULES:
			return []
		default:
			return state
	}
}